import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/feature/Layout";
import LoginPage from "@/pages/login/page";
import Dashboard from "@/pages/dashboard/page";
import Home from "@/pages/home/page";
import CleaningPage from "@/pages/cleaning/page";
import ReservationsPage from "@/pages/reservations/page";
import ReportsPage from "@/pages/reports/page";
import NotificationsPage from "@/pages/notifications/page";
import SettingsPage from "@/pages/settings/page";
import StaffPage from "@/pages/staff/page";
import AttendancePage from "@/pages/attendance/page";
import AttendanceAdminPage from "@/pages/attendance/admin/page";
import SetPasswordPage from "@/pages/set-password/page";
import AvailabilityPage from "@/pages/availability/page";
import ShiftsPage from "@/pages/shifts/page";
import ProfitLossPage from "@/pages/profit-loss/page";
import ReceivablesPage from "@/pages/receivables/page";
import GoldysClosingPage from "@/pages/goldys-closing/page";
import GoldysPage from "@/pages/goldys/page";
import PurchaseRequestsPage from "@/pages/purchase-requests/page";
import PayablesPage from "@/pages/payables/page";
import ReimbursementsPage from "@/pages/reimbursements/page";
import ContractsPage from "@/pages/contracts/page";
import MessagesPage from "@/pages/messages/page";
import AccountPage from "@/pages/account/page";
import DailyPayPage from "@/pages/daily-pay/page";
import { RequireAuth, RequireAdmin, RequireStaff, RequireFrontDeskOrAdmin, RequireHousekeepingOrAdmin, RequireOperations } from "@/components/feature/AuthGuard";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/set-password",
    element: <SetPasswordPage />,
  },
  {
    path: "/",
    element: <RequireAuth><Layout /></RequireAuth>,
    children: [
      {
        index: true,
        element: <RequireStaff><Home /></RequireStaff>,
      },
      {
        path: "casa",
        element: <RequireOperations><Dashboard /></RequireOperations>,
      },
      {
        path: "cleaning",
        element: <RequireHousekeepingOrAdmin><CleaningPage /></RequireHousekeepingOrAdmin>,
      },
      {
        path: "reservations",
        element: <RequireFrontDeskOrAdmin><ReservationsPage /></RequireFrontDeskOrAdmin>,
      },
      {
        path: "reports",
        element: <RequireAdmin><ReportsPage /></RequireAdmin>,
      },
      {
        path: "profit-loss",
        element: <RequireAdmin><ProfitLossPage /></RequireAdmin>,
      },
      {
        path: "receivables",
        element: <RequireAdmin><ReceivablesPage /></RequireAdmin>,
      },
      {
        path: "goldys",
        element: <RequireStaff><GoldysPage /></RequireStaff>,
      },
      {
        path: "goldys-closing",
        element: <RequireStaff><GoldysClosingPage /></RequireStaff>,
      },
      { path: "purchase-requests", element: <RequireStaff><PurchaseRequestsPage /></RequireStaff> },
      { path: "payables", element: <RequireAdmin><PayablesPage /></RequireAdmin> },
      { path: "reimbursements", element: <RequireStaff><ReimbursementsPage /></RequireStaff> },
      { path: "daily-pay", element: <RequireStaff><DailyPayPage /></RequireStaff> },
      { path: "contracts", element: <RequireAdmin><ContractsPage /></RequireAdmin> },
      {
        path: "notifications",
        element: <RequireStaff><NotificationsPage /></RequireStaff>,
      },
      {
        path: "messages",
        element: <RequireStaff><MessagesPage /></RequireStaff>,
      },
      {
        path: "account",
        element: <RequireStaff><AccountPage /></RequireStaff>,
      },
      {
        path: "settings",
        element: <RequireAdmin><SettingsPage /></RequireAdmin>,
      },
      {
        path: "staff",
        element: <RequireAdmin><StaffPage /></RequireAdmin>,
      },
      {
        path: "attendance",
        element: <RequireStaff><AttendancePage /></RequireStaff>,
      },
      {
        path: "attendance/admin",
        element: <RequireAdmin><AttendanceAdminPage /></RequireAdmin>,
      },
      {
        path: "availability",
        element: <RequireStaff><AvailabilityPage /></RequireStaff>,
      },
      {
        path: "shifts",
        element: <RequireStaff><ShiftsPage /></RequireStaff>,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
